// src/utils/contentModeration.js - FIXED VERSION
// Simple, effective content moderation without external dependencies

// Comprehensive profanity list (you can expand this)
const profanityList = [
  // English
  'fuck', 'shit', 'damn', 'bitch', 'asshole', 'bastard', 'crap', 'piss',
  'dick', 'cock', 'pussy', 'cunt', 'fag', 'slut', 'whore', 'nigger', 'nigga', 'faggot',
   'fuck', 'f*ck', 'fck', 'fuk',
  
  // Japanese offensive words
  'バカ', 'ばか', 'アホ', 'あほ', '死ね', 'しね', 'クソ', 'くそ',
  'ちんこ', 'まんこ', 'きちがい', 'キチガイ',

  // Add slang
  'wtf', 'stfu', 'gtfo',
  
  // Add leetspeak
  'b1tch', 'a$$hole',
  
  // Add more Japanese
  'ボケ', 'カス', 'ブス',
  
];

// Create regex patterns for case-insensitive matching
const profanityPatterns = profanityList.map(word => {
  // Escape special regex characters
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Match whole words with word boundaries (for English)
  if (/^[a-zA-Z]+$/.test(word)) {
    return new RegExp(`\\b${escaped}\\b`, 'gi');
  }
  // For non-English (like Japanese), just match the characters
  return new RegExp(escaped, 'gi');
});

/**
 * Check if text contains profanity
 */
const containsProfanity = (text) => {
  return profanityPatterns.some(pattern => pattern.test(text));
};

/**
 * Censor profanity in text
 */
const censorProfanity = (text) => {
  let censored = text;
  profanityPatterns.forEach(pattern => {
    censored = censored.replace(pattern, match => '*'.repeat(match.length));
  });
  return censored;
};

/**
 * Main moderation function
 */
export const moderateContent = (text) => {
  if (!text || typeof text !== 'string') {
    return {
      isClean: false,
      hasProfanity: false,
      isSpam: false,
      hasUrls: false,
      hasRepeatedChars: false,
      cleanedText: ''
    };
  }

  // Check for profanity
  const hasProfanity = containsProfanity(text);

  // Check for excessive caps (spam indicator)
  const capsCount = (text.match(/[A-Z]/g) || []).length;
  const totalLetters = (text.match(/[A-Za-z]/g) || []).length;
  const capsPercentage = totalLetters > 0 ? capsCount / totalLetters : 0;
  const isSpam = capsPercentage > 0.7 && text.length > 20;

  // Check for URLs
  const hasUrls = /https?:\/\/|www\./i.test(text);

  // Check for repeated characters (spam indicator)
  // Example: "aaaaaaa" or "!!!!!!!!"
  const hasRepeatedChars = /(.)\1{4,}/.test(text);

  // Check for excessive emojis (potential spam)
  const emojiCount = (text.match(/[\p{Emoji}]/gu) || []).length;
  const isEmojiSpam = emojiCount > 10;

  return {
    isClean: !hasProfanity && !isSpam && !hasRepeatedChars && !isEmojiSpam,
    hasProfanity,
    isSpam: isSpam || isEmojiSpam,
    hasUrls,
    hasRepeatedChars,
    cleanedText: censorProfanity(text)
  };
};

/**
 * Flag content for manual review
 */
export const flagContent = async (responseId, reason) => {
  console.log('🚩 Content flagged:', { responseId, reason });
  // This function is called from components, actual DB update happens there
  return { responseId, reason };
};

/**
 * Get moderation statistics for text
 */
export const getModerationStats = (text) => {
  const result = moderateContent(text);
  const warnings = [];
  
  if (result.hasProfanity) warnings.push('Contains inappropriate language');
  if (result.isSpam) warnings.push('Appears to be spam');
  if (result.hasUrls) warnings.push('Contains URLs');
  if (result.hasRepeatedChars) warnings.push('Has unusual character patterns');
  
  return {
    ...result,
    warnings,
    severity: result.hasProfanity || result.isSpam ? 'high' : 
              result.hasUrls || result.hasRepeatedChars ? 'medium' : 'low'
  };
};